import {
    addForm,
    cancelForm,
    reviseForm,
    updateForm
} from "./actions";

import FormsItemView from "./FormsItemView.vue"
import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import { get } from "lodash";
import revisions from "./internalAttachable";
import { standardDateLocal } from "../../../utils";

const dataFields = [{
    "label": "Form Number",
    "key": "FormNumber"
}, {
    "label": "Name",
    "key": "NameShort"
}, {
    "label": "Revision",
    "key": "Revision"
}, {
    "label": "Last Update",
    compute({ pageItem }) {
        const data = get(pageItem, `Revisions.${pageItem.RevisionID}.Date`, null);
        if(!data) return "No Date";
        return (new Date(data)).toLocaleDateString("en-gb", standardDateLocal);
    }
}];

const menuActions = [
    {
        "label": "Update Form Template",
        "action": updateForm
    },
    {
        "label": "Revise Form Template",
        "action": reviseForm
    },
    {
        "label": "Download Latest",
        async action({ db, pageItem, toast }) {
            if (!pageItem.RevisionID || !pageItem.Revisions?.[pageItem.RevisionID]?.File) {
                toast.warning("No file available for this form template.");
                return;
            }
            let rev = pageItem.Revisions[pageItem.RevisionID];
            let url = await db.download(`Database/DocumentTypes/${pageItem.ID}/Revisions/${pageItem.RevisionID}/${rev.File}`);
            window.open(url, "__blank");
        }
    },
    {
        "label": "Cancel Form Template",
        "action": cancelForm,
        "break": true,
        "class": "font-bold text-red"
    }
];

export default [{
    "path": "/Database/Forms",
    "component": {...ItemListView},
    "name": "Form Templates",
    "meta": {
        "app": "Database",
        "name": "Form Templates",
        "sideNav": true,
        "sideNavSection": "Forms, Handbooks & Work Instructions",
        "appSwitcher": false,
        "icon": "database",
        "tableSettings": "Forms",
        "dataPath": "Database/DocumentTypes",
        "dataPathOverride": "Database/DocumentTypes/:id",
        "selectionRoute": "Database/Forms/{ID}",
        "menuActions": [{
            "label": "Add Form Template",
            "action": addForm
        }, {
            "label": "Download All Latest Form Templates",
            async action({ db, store, toast, loadingModal }) {
                const allItems = Object.values(store.state["Database/DocumentTypes"] || {});
                const validItems = allItems.filter((item) => {
                    return item.RevisionID && item.Revisions?.[item.RevisionID]?.File;
                });

                if (!validItems.length) {
                    toast.warning("No form templates with files found.");
                    return;
                }

                loadingModal.value.open(validItems.length);

                try {
                    for (let i = 0; i < validItems.length; i++) {
                        const item = validItems[i];
                        const rev = item.Revisions[item.RevisionID];

                        loadingModal.value.setProgress(i, validItems.length, item.NameShort || item.FormNumber || "");

                        const url = await db.download(
                            `Database/DocumentTypes/${item.ID}/Revisions/${item.RevisionID}/${rev.File}`
                        );

                        // Fetch as blob so the browser saves directly — no new tab, no popup blocker
                        const response = await fetch(url);
                        const blob = await response.blob();
                        const blobUrl = URL.createObjectURL(blob);

                        const a = document.createElement("a");
                        a.href = blobUrl;
                        a.download = rev.File;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(blobUrl);

                        loadingModal.value.setProgress(i + 1, validItems.length, item.NameShort || item.FormNumber || "");
                    }
                } catch (e) {
                    console.error(e);
                    toast.error("An error occurred during bulk download.");
                } finally {
                    loadingModal.value.close();
                }
            }
        }],
        lock(user) {
            return [user?.Security?.Database?.Read !== true, "Cannot view this area"]
        }
    }
}, {
    "path": "/Database/Forms/:id",
    "component": FormsItemView,
    "name": "Form",
    "meta": {
        "app": "Database",
        "name": "Forms",
        "dataPath": "Database/DocumentTypes",
        "dataPathOverride": "Database/DocumentTypes/:id",
        "selectionRoute": "Database/Forms/{ID}",
        title(item) {
            return `Forms: ${item.NameShort}`
        },
        "attachedItems": {
            "Revisions": {
                "attachables": [revisions]
            }
        },
        "dataFields": dataFields,
        "menuActions": menuActions
    }
}];
